enum StatusPrecificacaoOperadoraEnum {
  PrecificacaoPendente = 'Precificação pendente',
  Precificado = 'Precificado',
}

export default StatusPrecificacaoOperadoraEnum
